module.exports = __webpack_public_path__ + "img/anh.007cdf4a.png";